import(/* webpackMode: "eager", webpackExports: ["NativeRedirect"] */ "/www/wwwroot/gass/fe-prod/components/landing/native-redirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/www/wwwroot/gass/fe-prod/node_modules/next/dist/client/app-dir/link.js");
